import React from "react";
import { Link } from "react-router-dom";

// components

import Navbar from "components/Navbars/AuthNavbar.js";
import Footer from "components/Footers/Footer.js";
import backgroundImage from "assets/img/landingpage-background-2.png";
import aboutImage from "assets/img/about-landingpage.png";
import programImage from "assets/img/program-landingpage.png";
import Help from "components/Footers/Help";

export default function Landing() {
  return (
    <>
    <Help />
      <Navbar transparent />
      <main>
      
        <div className="relative pt-16 pb-32 flex content-center items-center justify-center min-h-screen-75" id="#">
          <div
            className="absolute top-0 w-full h-full bg-center bg-cover"
            style={{
              backgroundImage:
                `url(${backgroundImage})`,
            }}
          >
            <span
              id="blackOverlay"
              className="w-full h-full absolute opacity-75 bg-black"
            ></span>
          </div>
          <div className="container relative mx-auto">
            <div className="items-center flex flex-wrap">
              <div className="w-full lg:w-6/12 px-4 ml-auto mr-auto text-center">
                <div className="pr-12">
                  <h1 className="text-white font-semibold text-3xl">
                    NAVDAA CENDEKIA
                  </h1>
                  <p className="mt-4 text-lg text-blueGray-200">
                  Les privat untuk TK/PAUD, SD, SMP, SMA, UTBK SBMPTN, dan Umum. 
                  Kualitas pengajar terjamin dan berpengalaman di bidangnya. Kamu juga bisa atur kebutuhan belajarmu.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div
            className="top-auto bottom-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden h-70-px"
            style={{ transform: "translateZ(0)" }}
          >
            <svg
              className="absolute bottom-0 overflow-hidden"
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100"
              x="0"
              y="0"
            >
              <polygon
                className="text-blueGray-200 fill-current"
                points="2560 0 2560 100 0 100"
              ></polygon>
            </svg>
          </div>
        </div>

        <section className="pb-20 bg-blueGray-200 -mt-24">
          <div className="container mx-auto px-4">
            <div className="flex flex-wrap">
              <div className="lg:pt-12 pt-6 w-full md:w-4/12 px-4 text-center">
                <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg">
                  <div className="px-4 py-5 flex-auto">
                    <div className="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-red-400">
                      <i className="fas fa-book"></i>
                    </div>
                    <h6 className="text-xl font-semibold">Pembelajaran</h6>
                    <p className="mt-2 mb-4 text-blueGray-500">
                      Pendekatan dalam proses pembelajaran yang khusus sehingga lebih menyenangkan dan tidak cepat bosan
                    </p>
                  </div>
                </div>
              </div>

              <div className="w-full md:w-4/12 px-4 text-center">
                <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg">
                  <div className="px-4 py-5 flex-auto">
                    <div className="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-lightBlue-400">
                      <i className="fas fa-chalkboard-teacher"></i>
                    </div>
                    <h6 className="text-xl font-semibold">Profesional</h6>
                    <p className="mt-2 mb-4 text-blueGray-500">
                      Pengajar yang profesional serta terjamin kualitasnya dalam proses mengajar
                    </p>
                  </div>
                </div>
              </div>

              <div className="pt-6 w-full md:w-4/12 px-4 text-center">
                <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg">
                  <div className="px-4 py-5 flex-auto">
                    <div className="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-emerald-400">
                      <i className="fas fa-clipboard-check"></i>
                    </div>
                    <h6 className="text-xl font-semibold">Evaluasi</h6>
                    <p className="mt-2 mb-4 text-blueGray-500">
                      Terdapat sistem evaluasi selama proses pembelajaran serta feedback untuk meningkatkan kemampuan berpikir
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap items-center mt-32" id="about">
              <div className="w-full md:w-5/12 px-4 mr-auto ml-auto">
                <div className="text-blueGray-500 p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-6 shadow-lg rounded-full bg-white">
                  <i className="fas fa-history text-xl"></i>
                </div>
                <h3 className="text-3xl mb-2 font-semibold leading-normal">
                  Tentang
                </h3>
                <p className="text-lg font-light leading-relaxed mt-4 mb-4 text-blueGray-600">
                  Navdaa Cendekia merupakan organisasi les privat yang berdiri sejak 2021. 
                  Memiliki motivasi untuk mengembangkan kemampuan siswa dalam jenjang pendidikan manapun. 
                  Berusaha sebaik mungkin dalam membantu siswa belajar
                </p>
                <p className="text-lg font-light leading-relaxed mt-0 mb-4 text-blueGray-600">
                  <b>Tujuan utama kami adalah membantu siswa dalam proses belajar</b>
                </p>
                <a href="https://linktr.ee/navdaacendekia" className="font-bold text-blueGray-700 mt-8" target="_blank">
                <button
                        className="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                        type="button"
                        target="_blank"
                      >Hubungi Kami!</button>
                </a>
              </div>

              <div className="w-full md:w-4/12 px-4 mr-auto ml-auto">
                <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded-lg bg-lightBlue-500">
                  <img
                    alt="about-image"
                    src={aboutImage}
                    className="object-cover align-middle rounded-t-lg"
                  />
                  <blockquote className="relative p-8 mb-4">
                    <svg
                      preserveAspectRatio="none"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 583 95"
                      className="absolute left-0 w-full block h-95-px -top-94-px"
                    >
                      <polygon
                        points="-30,95 583,95 583,65"
                        className="text-lightBlue-500 fill-current"
                      ></polygon>
                    </svg>
                    <h4 className="text-xl font-bold text-white">
                      Alamat
                    </h4>
                    <p className="text-md font-light mt-2 text-white">
                      Banjarjo, RT.18, Dusun 2, Tegaldowo, Kec. Gemolong, Kabupaten Sragen, Jawa Tengah 57274
                    </p>
                  </blockquote>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="relative py-20">
          <div
            className="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20 h-20"
            style={{ transform: "translateZ(0)" }}
          >
            <svg
              className="absolute bottom-0 overflow-hidden"
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100"
              x="0"
              y="0"
            >
              <polygon
                className="text-white fill-current"
                points="2560 0 2560 100 0 100"
              ></polygon>
            </svg>
          </div>

          <div className="container mx-auto px-4" id="program">
            <div className="items-center flex flex-wrap">
              <div className="w-full md:w-4/12 ml-auto mr-auto px-4">
                <img
                  alt="..."
                  className="max-w-full rounded-lg shadow-lg"
                  src={programImage}
                />
              </div>
              <div className="w-full md:w-5/12 ml-auto mr-auto px-4">
                <div className="md:pr-12">
                  <div className="text-lightBlue-600 p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-6 shadow-lg rounded-full bg-lightBlue-300">
                    <i className="fas fa-tasks text-xl"></i>
                  </div>
                  <h3 className="text-3xl font-semibold">Program Kami</h3>
                  <p className="mt-4 text-lg leading-relaxed text-blueGray-500">
                    Terdapat beberapa program yang kami sediakan. Banyak manfaat dan keunggulan dari setiap program. Pilih sekarang juga!!
                  </p>
                  <ul className="list-none mt-6">
                    <li className="py-2">
                      <div className="flex items-center">
                        <div>
                          <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-lightBlue-600 bg-lightBlue-200 mr-3">
                            <i className="fas fa-fingerprint"></i>
                          </span>
                        </div>
                        <div>
                          <h4 className="text-blueGray-500">
                            Privat Eksklusif
                          </h4>
                        </div>
                      </div>
                    </li>
                    <li className="py-2">
                      <div className="flex items-center">
                        <div>
                          <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-lightBlue-600 bg-lightBlue-200 mr-3">
                            <i className="fab fa-html5"></i>
                          </span>
                        </div>
                        <div>
                          <h4 className="text-blueGray-500">
                            Privat Kelompok
                          </h4>
                        </div>
                      </div>
                    </li>
                    <li className="py-2">
                      <div className="flex items-center">
                        <div>
                          <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-lightBlue-600 bg-lightBlue-200 mr-3">
                            <i className="far fa-paper-plane"></i>
                          </span>
                        </div>
                        <div>
                          <h4 className="text-blueGray-500">
                            Reguler
                          </h4>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="pt-20 pb-48">
  <div className="container mx-auto px-4">
    <div className="flex flex-wrap justify-center text-center mb-16">
      <div className="w-full lg:w-6/12 px-4">
        <h2 className="text-3xl md:text-4xl font-semibold">Pesan dan Kesan</h2>
        <p className="text-base md:text-lg leading-relaxed m-4 text-blueGray-500">
          Ulasan dan testimoni beberapa siswa terhadap kami.
        </p>
      </div>
    </div>
    <div className="flex flex-wrap gap-4">
      <div className="w-full sm:w-6/12 md:w-4/12 lg:w-3/12 mb-12 px-4 border-2 rounded-lg shadow-lg">
        <div className="px-6">
          <div className="pt-6 text-center">
            <h5 className="text-lg md:text-xl font-bold">Alfira (XI SMA)</h5>
            <p className="mt-1 text-sm text-blueGray-400 font-semibold">
              <i>"Seru dan kakaknya menjelaskan dengan detail"</i>
            </p>
            <div className="mt-6">
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
            </div>
          </div>
        </div>
      </div>
      <div className="w-full sm:w-6/12 md:w-4/12 lg:w-3/12 mb-12 px-4 border-2 rounded-lg shadow-lg">
        <div className="transition ease-in-out delay-150 bg-blue-500 hover:-translate-y-1 hover:scale-110 hover:bg-indigo-500 duration-300 px-6">
          <div className="pt-6 text-center">
            <h5 className="text-lg md:text-xl font-bold">Kanisa (III SD)</h5>
            <p className="mt-1 text-sm text-blueGray-400 font-semibold">
              <i>"Alhamdulillah baik kak, masyaAllah rata-rata nilai secara keseluruhan semua mapel 91. Nilai ujian kemarin ada 3 mapel yang nilainya sempurna"</i>
            </p>
            <div className="mt-6">
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
            </div>
          </div>
        </div>
      </div>
      <div className="w-full sm:w-6/12 md:w-4/12 lg:w-3/12 mb-12 px-4 border-2 rounded-lg shadow-lg">
        <div className="transition ease-in-out delay-150 bg-blue-500 hover:-translate-y-1 hover:scale-110 hover:bg-indigo-500 duration-300 px-6">
          <div className="pt-6 text-center">
            <h5 className="text-lg md:text-xl font-bold">Ainayya (I SD)</h5>
            <p className="mt-1 text-sm text-blueGray-400 font-semibold">
              <i>"MasyaAllah rata-rata nilainya 89, nilai ujiannya juga Alhamdulillah baik semua"</i>
            </p>
            <div className="mt-6">
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
            </div>
          </div>
        </div>
      </div>
      <div className="w-full sm:w-6/12 md:w-4/12 lg:w-3/12 mb-12 px-4 border-2 rounded-lg shadow-lg">
        <div className="transition ease-in-out delay-150 bg-blue-500 hover:-translate-y-1 hover:scale-110 hover:bg-indigo-500 duration-300 px-6">
          <div className="pt-6 text-center">
            <h5 className="text-lg md:text-xl font-bold">Mikail (Calistung)</h5>
            <p className="mt-1 text-sm text-blueGray-400 font-semibold">
              <i>"Alhamdulillah bun, banyak perkembangan dari membacanya. Serta untuk hafalan surat pendeknya bisa lebih dilancarkan bun"</i>
            </p>
            <div className="mt-6">
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>


        <section className="pb-20 relative block bg-blueGray-800" id="kontak">
          <div
            className="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20 h-20"
            style={{ transform: "translateZ(0)" }}
          >
            <svg
              className="absolute bottom-0 overflow-hidden"
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100"
              x="0"
              y="0"
            >
              <polygon
                className="text-blueGray-800 fill-current"
                points="2560 0 2560 100 0 100"
              ></polygon>
            </svg>
          </div>

          <div className="container mx-auto px-4 lg:pt-24 lg:pb-64">
            <div className="flex flex-wrap text-center justify-center">
              <div className="w-full lg:w-6/12 px-4">
                <h2 className="text-4xl font-semibold text-white mb-16">
                  Hubungi Kami
                </h2>
                <p className="text-lg leading-relaxed mt-4 mb-4 text-blueGray-400">
                  Temukan kami dalam berbagai platfrom sosial media. Bila anda memiliki pertanyaan, silahkan hubungi kami melalui platform dibawah ini.
                </p>
              </div>
            </div>
            <div className="flex flex-wrap mt-12 justify-center">
              <div className="w-full lg:w-3/12 px-4 text-center">
                <div className="text-blueGray-800 p-3 w-12 h-12 shadow-lg rounded-full bg-white inline-flex items-center justify-center">
                  <i className="fab fa-instagram text-xl"></i>
                </div>
                <h6 className="text-xl mt-5 font-semibold text-white">
                  Instagram
                </h6>
                <p className="mt-2 mb-4 text-blueGray-400">
                  @navdaacendekia
                </p>
              </div>
              <div className="w-full lg:w-3/12 px-4 text-center">
                <div className="text-blueGray-800 p-3 w-12 h-12 shadow-lg rounded-full bg-white inline-flex items-center justify-center">
                  <i className="fab fa-facebook text-xl"></i>
                </div>
                <h5 className="text-xl mt-5 font-semibold text-white">
                  Facebook
                </h5>
                <p className="mt-2 mb-4 text-blueGray-400">
                  @navdaacendekia
                </p>
              </div>
              <div className="w-full lg:w-3/12 px-4 text-center">
                <div className="text-blueGray-800 p-3 w-12 h-12 shadow-lg rounded-full bg-white inline-flex items-center justify-center">
                  <i className="fab fa-whatsapp text-xl"></i>
                </div>
                <h5 className="text-xl mt-5 font-semibold text-white">
                  Whatsapp
                </h5>
                <p className="mt-2 mb-4 text-blueGray-400">
                  +6285329075397
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
